// src/data/comedians/bill-burr.js

const base = {
  id: 'bill-burr',
  slug: 'bill-burr',
  name: 'Bill Burr',
  birthYear: 1968,
  image: require('@/assets/images/img_Bill_Burr.jpg'),
  famousWorks: [
    'Paper Tiger (2019)',
    'Walk Your Way Out (2017)',
    'F is for Family (creator)',
    'Monday Morning Podcast',
    'Breaking Bad',
    'The Mandalorian',
    'Old Dads (2023)',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'American',
    shortBio: 'Unfiltered Boston truth-teller',
    bio: `Bill Burr is an American stand-up comedian, actor, and podcaster known for his honest, aggressive style and rants about modern life, sports, and gender dynamics. His no-nonsense approach and willingness to express unpopular opinions have made him one of comedy's most respected voices.\n\nBorn in Canton, Massachusetts, Burr moved to New York City to pursue comedy in the early 1990s. He spent years developing his craft in clubs before gaining wider recognition. His breakout moment came with viral videos of his performances, particularly his legendary Philadelphia incident where he turned a hostile crowd in his favor.\n\nBurr's Netflix specials have been critically acclaimed, and he has successfully transitioned into acting with roles in "Breaking Bad" and his own animated series "F is for Family." His podcast "Monday Morning Podcast" has become one of the most popular in comedy, showcasing his ability to connect with audiences through long-form improvisation.`,
    style: 'Aggressive, honest, observational rants, Boston attitude',
    achievements: [
      'Grammy Award nomination',
      'Emmy nominations',
      'Successful podcast with millions of listeners',
      'Sold-out arena tours worldwide',
      'Critical acclaim for stand-up specials',
      'Successful voice acting and animation work',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Américain',
    shortBio: 'Dise-tout de Boston, sans filtre',
    bio: `Bill Burr est un comédien de stand-up, acteur et podcasteur américain connu pour son style honnête et agressif et ses diatribes sur la vie moderne, le sport et la dynamique des genres. Son approche sans compromis et sa volonté d'exprimer des opinions impopulaires en font l'une des voix les plus respectées de la comédie.\n\nNé à Canton, Massachusetts, Burr s'est installé à New York pour poursuivre la comédie au début des années 1990. Il a passé des années à développer son art dans les clubs avant d'être plus largement reconnu. Sa percée est venue avec des vidéos virales de ses performances, notamment le légendaire incident de Philadelphie où il a retourné une foule hostile en sa faveur.\n\nLes specials Netflix de Burr ont été acclamés par la critique, et il a réussi à passer au jeu d'acteur avec des rôles dans "Breaking Bad" et sa propre série animée "F is for Family".`,
    style: 'Agressif, honnête, diatribes observationnelles, attitude de Boston',
    achievements: [
      'Nomination aux Grammy Awards',
      'Nominations aux Emmy Awards',
      'Podcast populaire avec des millions d\'auditeurs',
      'Tournées d\'arènes sold-out dans le monde',
      'Acclamation critique pour les specials stand-up',
      'Travail réussi de doublage et d\'animation',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Americano',
    shortBio: 'Bocazas sin filtro de Boston',
    bio: `Bill Burr es un comediante de stand-up, actor y podcaster estadounidense conocido por su estilo honesto y agresivo y sus diatribas sobre la vida moderna, los deportes y la dinámica de género. Su enfoque sin rodeos y su disposición a expresar opiniones impopulares lo han convertido en una de las voces más respetadas de la comedia.\n\nNacido en Canton, Massachusetts, Burr se mudó a Nueva York para dedicarse a la comedia a principios de los años 90. Pasó años perfeccionando su arte en clubs antes de obtener un reconocimiento más amplio. Su momento de revelación llegó con videos virales de sus actuaciones, especialmente el legendario incidente de Filadelfia donde convirtió a una multitud hostil en su favor.\n\nLos especiales de Netflix de Burr han sido aclamados por la crítica, y ha logrado pasar a la actuación con papeles en "Breaking Bad" y su propia serie animada "F is for Family".`,
    style: 'Agresivo, honesto, diatribas observacionales, actitud de Boston',
    achievements: [
      'Nominación al Grammy Award',
      'Nominaciones a los Emmy',
      'Podcast exitoso con millones de oyentes',
      'Giras de arena agotadas en todo el mundo',
      'Aclamación crítica por los especiales de stand-up',
      'Exitoso trabajo de doblaje y animación',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'أمريكي',
    shortBio: 'صاحب الحقيقة غير المرشّحة من بوسطن',
    bio: `بيل بور كوميدي ستاند أب وممثل وبودكاستر أمريكي اشتُهر بأسلوبه الصريح والعدواني وصيحاته حول الحياة الحديثة والرياضة وديناميكيات الجنسين. نهجه العملي واستعداده للتعبير عن آراء غير شعبية جعلا منه أحد أكثر أصوات الكوميديا احترامًا.\n\nوُلد في كانتون بماساتشوستس وانتقل إلى نيويورك لمتابعة مسيرته في الكوميديا مطلع التسعينيات. أمضى سنوات يصقل موهبته في النوادي قبل الانتشار الواسع. جاء اختراقه مع مقاطع فيروسية من عروضه، لا سيما الحادثة الأسطورية في فيلادلفيا حيث حوّل جمهورًا معاديًا لصالحه.\n\nحظيت عروضه الخاصة على Netflix بإشادة نقدية، كما انتقل بنجاح إلى التمثيل بأدوار في "Breaking Bad" ومسلسله الرسوم المتحركة "F is for Family". بودكاسته "Monday Morning Podcast" أصبح من أشهر البودكاستات الكوميدية.`,
    style: 'عدواني وصريح، إطناب ملاحظاتي، روح بوسطن',
    achievements: [
      'ترشيح لجائزة Grammy',
      'ترشيحات لجوائز Emmy',
      'بودكاست ناجح بملايين المستمعين',
      'جولات عالمية بطاقة كاملة في الملاعب',
      'إشادة نقدية بالعروض الخاصة',
      'عمل ناجح في التمثيل الصوتي والرسوم المتحركة',
    ],
  },
];
